<div class="modal-header player-search-header px-0">
  <div class="d-flex flex-grow-1">
    <div class="flex-grow-1 justify-content-end">
      <div>
        <h5 class="modal-title text-left">{{'ChangePlayer.Title' | translate}} </h5>
      </div>
    </div>
    <div class="flex-grow-1 d-flex justify-content-end">
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()"
        class="btn btn-light-blue-outline btn-sm">{{'General.Dismiss' | translate}}</button>

      <button type="button" (click)="update()" [disabled]="!(selectedPlayer$ | async)"
        class="btn btn-light-blue btn-sm ml-2">{{'General.Update' | translate}}</button>
    </div>
  </div>
</div>
<div class="modal-body bay-club-light-blue-2-bg">
  <div class="player-tabs d-flex flex-row">
    <div class="player-tab" [ngClass]="{'player-tab-active': isSearchTabActive}" translate
      (click)="setSearchTabActive()">ChangePlayer.SearchPlayerTab</div>
    <div class="player-tab" [ngClass]="{'player-tab-active': isAddNewPlayerTabActive}" translate
      (click)="setAddPlayerTabActive()">ChangePlayer.AddNewPlayerTab</div>
  </div>
  <app-player-search *ngIf="isSearchTabActive"></app-player-search>
  <app-player-add *ngIf="isAddNewPlayerTabActive"></app-player-add>
  <div class="player-change mt-3" *ngIf="(player$ | async).loaded">
    <app-change-player-panel [player]="(player$ | async).data" [changedPlayer]="(selectedPlayer$ | async)"
      [playerRules]="selectedPlayerRulesMatrix$ | async" [categoryName]="changePlayerInput.categoryCode | categoryName">
    </app-change-player-panel>
  </div>
</div>
